module.exports = __webpack_public_path__ + "img/e1.5a5697b7.png";